import { useEffect } from "react";
import { MapContainer, TileLayer, Polyline, Marker, Circle, Popup, useMap } from "react-leaflet";
import L from "leaflet";

const pin = (color, label) =>
  L.divIcon({
    className: "",
    html: `<div style="background:${color};color:#0b0f17;border:3px solid #fff;border-radius:14px;padding:4px 8px;font:800 13px 'Barlow Condensed',sans-serif;box-shadow:0 6px 18px rgba(0,0,0,.5);white-space:nowrap">${label}</div>`,
    iconAnchor: [20, 16],
  });

const truck = L.divIcon({
  className: "",
  html: `<div class="nv-truck"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0b0f17" stroke-width="2.6"><path d="M12 2 4 21l8-4 8 4z" fill="#0b0f17"/></svg></div>`,
  iconSize: [52, 52],
  iconAnchor: [26, 26],
});

const Follow = ({ pos, follow }) => {
  const map = useMap();
  useEffect(() => {
    if (follow && pos) map.setView(pos, Math.max(map.getZoom(), 12), { animate: true });
  }, [pos, follow, map]);
  return null;
};

const FitRoute = ({ geometry }) => {
  const map = useMap();
  useEffect(() => {
    if (geometry?.length > 1) map.fitBounds(L.latLngBounds(geometry), { padding: [60, 60] });
  }, [geometry, map]);
  return null;
};

export const NavMap = ({ pos, route, passedIdx, dest, alerts, pois = [], follow }) => {
  const geom = route?.geometry || [];
  return (
    <MapContainer center={pos || [44.5, 11]} zoom={7} minZoom={2} maxBounds={[[-85, -180], [85, 180]]} maxBoundsViscosity={1} worldCopyJump={false} className="h-full w-full" zoomControl={false} data-testid="nav-map">
      <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" className="nv-dark-tiles" noWrap bounds={[[-85, -180], [85, 180]]} />
      {geom.length > 1 && (
        <>
          <Polyline positions={geom} pathOptions={{ color: "#0b0f17", weight: 12, opacity: 0.8 }} />
          <Polyline positions={geom.slice(passedIdx)} pathOptions={{ color: "#4accff", weight: 7 }} />
          <Polyline positions={geom.slice(0, passedIdx + 1)} pathOptions={{ color: "#64748b", weight: 6 }} />
        </>
      )}
      {alerts.map((a) => (
        <Circle key={a.id} center={[a.lat, a.lng]} radius={(a.radius_km || 2) * 1000} pathOptions={{ color: "#ef0298", fillColor: "#ef0298", fillOpacity: 0.25 }}>
          <Popup><b>ANAS · {a.road}</b><br />{a.title}<br />{a.description}</Popup>
        </Circle>
      ))}
      {alerts.map((a) => <Marker key={`m${a.id}`} position={[a.lat, a.lng]} icon={pin("#ef0298", "⚠ ANAS")} />)}
      {pois.map((p) => <Marker key={p.id} position={[p.lat, p.lng]} icon={pin("#f59e0b", p.name.slice(0, 18))} />)}
      {dest && <Marker position={[dest.lat, dest.lng]} icon={pin("#ffffff", dest.name.slice(0, 24))} />}
      {pos && <Marker position={pos} icon={truck} zIndexOffset={1000} />}
      <Follow pos={pos} follow={follow} />
      {!follow && <FitRoute geometry={route?.geometry} />}
    </MapContainer>
  );
};
